/**
 * 标签正则常量（F-M13 从 tagParser.ts 拆分）
 *
 * 集中所有 SSE 流式文本中可能出现的标签正则：
 *   - THINK / TOOL_CALL：思考与工具调用
 *   - CALL_AGENT / CALL_AGENT_ASYNC：同步/异步 agent 调用
 *   - COLLABORATION_RESULT：协作结果
 *   - COLLAB_STATUS：协作阶段状态
 *
 * 这些正则使用 /g 标志，可被 extract* 函数循环 exec。
 * 调用方负责在使用前重置 lastIndex = 0。
 */

// [THINK]...[/THINK] 或 <think>...</think>
export const THINK_TAG_RE = /\[THINK\]([\s\S]*?)\[\/THINK\]|<think[^>]*>([\s\S]*?)<\/think>/g;

// [TOOL_CALL]...[/TOOL_CALL] 或 <tool_call>...</tool_call>
export const TOOL_CALL_TAG_RE = /\[TOOL_CALL\]([\s\S]*?)\[\/TOOL_CALL\]|<tool_call[^>]*>([\s\S]*?)<\/tool_call>/g;

// [CALL_AGENT:xxx]...[/CALL_AGENT] 或 [/CALL_AGENT:xxx]
export const CALL_AGENT_TAG_RE = /\[CALL_AGENT:([^\]]+)\]([\s\S]*?)\[\/CALL_AGENT(?::[^\]]*)?\]/g;

// [CALL_AGENT_ASYNC:xxx]...[/CALL_AGENT_ASYNC]
export const CALL_AGENT_ASYNC_TAG_RE = /\[CALL_AGENT_ASYNC:([^\]]+)\]([\s\S]*?)\[\/CALL_AGENT_ASYNC(?::[^\]]*)?\]/g;

// [COLLABORATION_RESULT] 或 [COLLABORATION_RESULT:callId]...[/COLLABORATION_RESULT]
export const COLLABORATION_RESULT_TAG_RE = /\[COLLABORATION_RESULT(?::([^\]]*))?\]([\s\S]*?)\[\/COLLABORATION_RESULT(?::[^\]]*)?\]/g;

// [COLLAB_STATUS:phase]...[/COLLAB_STATUS]
export const COLLAB_STATUS_TAG_RE = /\[COLLAB_STATUS:(\w+)\]([\s\S]*?)\[\/COLLAB_STATUS\]/g;

/**
 * 流式分片判断：检测文本是否包含任意已知标签开头。
 * 用于 chunk handler 决定是否缓冲当前 chunk 等待完整标签。
 */
export const TAG_PATTERN = /\[(THINK|TOOL_CALL|CALL_AGENT|CALL_AGENT_ASYNC|COLLABORATION_RESULT|COLLAB_STATUS|ROUTE|REMINDER|COLLAB_CTX|GENERATED_PROMPT)\b/i;

/**
 * 流式分片判断：检测 HTML 风格的 <think> 开标签。
 */
export const ALT_TAG_PATTERN = /<think[^>]*>/;
